import { WtButton } from "../Button/button";
import styles from "./calltransfersuccess.module.scss";
import { useSelector } from "react-redux";
import userImg from "../../../styles/images/successGreen.svg";
import { CallPopUpAgentActions } from "../../../store/slices/voice_call_slice/call_popup_agent";
import { useDispatcher } from "../../../custom_hooks/use_app_dispatch";
import { dispositionSliceActions } from "../../../store/slices/dispositionSlice/postDisposition";
import { hassAccess, summarySubjectHandlerForCall } from "../../../base/utils";
import { ChatActions } from "../../../store/slices/chat_slice/chat_slice";

function CallTransferSuccess() {
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  const dispositionData:any = useSelector((state: any) => state.dispositionData);
  let {started,storeInterval} = dispositionData;
  const chatReducer = useSelector((state: any) => state.chatReducer);

  const dispatch = useDispatcher();
  const closetransfer=()=>{
    if (!started) {
      clearInterval(storeInterval);
    let  InterValData = setInterval(() => {
        dispatch(dispositionSliceActions.startDispositionTimer());
      }, 1000);
      dispatch(dispositionSliceActions.storeIntervalData(InterValData));
    }
     hassAccess('Disposition/regenerate') && summarySubjectHandlerForCall(chatReducer?.callSessionId, dispatch,1)
    //  summarySubjectHandlerForCall(chatReducer?.callSessionId, dispatch, 1)
     dispatch(ChatActions.setCallSessionList({ state: true, sessionId: chatReducer?.callSessionId?? "" }));
    
    // dispatch(dispositionSliceActions.setDispositionOpen({isOpenDisPositionStatus:true}));
    dispatch(CallPopUpAgentActions.TransferSuccess());
  }


  return (
    <>
      {popUpDetails.isTransferSuccess && (
        <div className={`w3-animate-top ${styles.callcontainartopsec}`}>
          <div className={`${styles.callwhisperinnercon} ${styles.calltransscussesswidges}`}>
            <div className={styles.succesconsec}>
              <label>
                <img src={userImg} alt="" className={styles.userImage} />
              </label>
              <span>The call has been transferred successfully</span>
              <WtButton onClick={closetransfer}
                className={`buttonGreen ${styles.showcallbtn}`}
                name="Close"
              />
            </div>
          </div>
        </div>
      )}
      {/*     
      {opendialPadDetails.isTransferPopupOpen&& <div className={`w3-animate-top ${styles.callcontainartopsec}`}>
        <div className={styles.transferingCall}>
          <img src={transferingImg} alt="" />
          <p className={styles.transferingTitle}>Transferring call</p>
          <p className={styles.loadingIcon}><Lottie style={{ "width": 50, "margin": "0 auto" }}
            animationData={groovyWalkAnimation} /></p>
        </div>
      </div>} */}
    </>
  );
}
export default CallTransferSuccess;
